import axios from 'api/axios'
import { Payment } from 'types'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for getPayments
 */

export interface getPaymentsParams {
	page: number
	size: number
	client?: string
}

/**
 * Type Interface for the Response object you get from getPayments request if successful
 */
export interface paymentResponse {
	totalCount: number
	records: Payment[]
	totalPages: number
	currentPage: number
}

export interface getPaymentsResponse {
	response: paymentResponse
	filter: {}
}

/**
 * API call to get Payment from the WhatCX Application
 * @param options getPaymentsParams - Options for the API call
 * @returns PaymentResponse - Response object returned from the server
 */

export const getPayments = async (options: getPaymentsParams) => {
	try {
		const { page = 1, size = 10, client = '' } = options
		const { data } = await axios.get<getPaymentsResponse>(
			`client/bill/payments?page=${page}&size=${size}${
				client.length > 0 ? `&client=${client}` : ''
			}`
		)
		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default getPayments
